const initialState = {
    date: '',
    type: ''
};

const dateTimeReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_DATETIME':
            return {
                ...state,
                date: action.payload.date,
                type: action.payload.type
            };
        default:
            return state;
    }
};

export default dateTimeReducer;